/*----------------------------------------------------------------------------*\
  #DROPDOWN
\*----------------------------------------------------------------------------*/

// Default module export
export default function(options) {
  // Private: Default settings object
  const _defaults = {
    selector: '.js-dropdown',
    $dropdowns() {
      return document.querySelectorAll(this.selector);
    },
    exists() {
      return this.$dropdowns().length > 0;
    },
  };

  // Private: Merge passed in object with defaults
  const _settings = {
    ..._defaults,
    ...options,
  };

  // Private: Open state of dropdown
  let _open = false;

  // Private: Toggle dropdown method
  const _toggleDropdown = event => {
    // Stops this same click from bubbling up to the document handler below and
    // immediately closing the dropdown it just opened.
    event.stopPropagation();

    const $dropdown = event.currentTarget.closest('.js-dropdown');
    const $menu = $dropdown.querySelector('.c-dropdown__menu');

    $dropdown.classList.toggle('is-open');

    _open = !$dropdown.classList.contains('is-open');
    $menu.setAttribute('aria-hidden', _open);
  };

  // Private: Close every open dropdown
  const _closeAllDropdowns = () => {
    _settings.$dropdowns().forEach($dropdown => {
      $dropdown.classList.remove('is-open');
      $dropdown.querySelector('.c-dropdown__menu').setAttribute('aria-hidden', 'true');
    });
  };

  // Private: Close dropdowns when clicking anywhere outside of them
  const _documentClickHandler = () => _closeAllDropdowns();

  // Public: Destroy module instance
  const destroy = () => {
    if (!_settings.exists()) return;

    const $buttons = document.querySelectorAll('.js-dropdownButton');
    $buttons.forEach($button =>
      $button.removeEventListener('click', _toggleDropdown)
    );

    document.removeEventListener('click', _documentClickHandler);
  };

  // Public: Destroy module instance and run initialise again
  const reinit = () => {
    destroy();
    init();
  };

  // Public: Initialise module
  const init = () => {
    if (!_settings.exists()) return;

    const $buttons = document.querySelectorAll('.js-dropdownButton');
    $buttons.forEach($button =>
      $button.addEventListener('click', _toggleDropdown)
    );

    document.addEventListener('click', _documentClickHandler);
  };

  // Return public methods
  return {
    destroy,
    reinit,
    init,
  };
}
